
<script>
  let { ...rest } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="2 2 22 22"
  fill="currentColor"
  {...rest}
>
  <path
    d="M 19.28125 5.28125 L 9 15.5625 L 4.71875 11.28125 L 3.28125 12.71875 L 8.28125 17.71875 L 9 18.40625 L 9.71875 17.71875 L 20.71875 6.71875 Z"
  />
</svg>
